import type { MutationHookOptions } from '@apollo/client'
import {
  PeopleTeamCreateTeamDocument,
  PeopleTeamCreateTeamMutation,
  PeopleTeamCreateTeamMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type CreateTeamsTeamPayload = NonNullable<
  PeopleTeamCreateTeamMutation['teamsMutations']['createTeamsTeam']
>

type Options = MutationHookOptions<
  PeopleTeamCreateTeamMutation,
  PeopleTeamCreateTeamMutationVariables,
  CreateTeamsTeamPayload
>
export type NewTeam = Omit<CreateTeamsTeamPayload, 'errors'>
export const usePeopleTeamCreateTeam = (options?: Options) => {
  const [createTeam, { loading }] = useMutation(PeopleTeamCreateTeamDocument, {
    ...options,
    extractorFn: (data) => data.teamsMutations.createTeamsTeam,
  })

  return {
    loading,
    create: createTeam,
  }
}
